export const pageSizeDelimiters = ['5', '10', '20', '25', '50', '100'];

export const baseTableOptions = {
  columnResizeMode: 'onChange',
  defaultColumn: {
    maxSize: 400,
    minSize: 30,
  },
};

export const initialBOTableState = { tableVariant: 'new' };
